<template>
	<div id="app">
		<Top />
		<router-view></router-view>
		<Loading :loading="loading" />
		<Footer />
	</div>
</template>

<script>
	import Loading from "./components/loading.vue";
	import Top from "./components/top.vue";
	import Footer from "./components/footer.vue";

	export default {
		name: "app",
		components: {
			Loading,
			Top,
			Footer,
		},
		data() {
			return {
				loading: false
			};
		},
		mounted: function () {
			const $this = this;
			this.bus.$on("loading", function (flag) {
				$this.loading = flag ? true : false;
			});
			this.bus.$on("animate", function () {
				setTimeout(function () {
					document.body.className = document.body.className + ' animate';
				}, 100);
			});
		},
	};
</script>